<script>
import ModalDetalleValidaciones from "./modal/ModalDetalleValidaciones.vue";
import {service} from "./../../../helpers/service.js";
import Layout from "../../../router/layouts/main.vue";
import PageHeader from "@/components/page-header";
import useVuelidate from "@vuelidate/core";
import { PaginationWithRangeMix } from '../../../mixes/PaginationMix';

const acceptXML = ".xml, text/application";
// const acceptXML = ".xml, .zip, text/application";

const headers = [
  {
    index: "nombre_archivo",
    label: "Nombre archivo",
    filter: false,
  },
  {
    index: "uuid_cfdi",
    label: "UUID CFDI",
    filter: false,
  },
  {
    index: "resultado_carga",
    label: "Resultado carga",
    filter: false,
    selected: false,
  },
  {
    index: "error",
    label: "Error",
    filter: false,
    selected: false,
  },
  {
    index: "detalle_mensaje",
    label: "Detalle",
    filter: false,
    selected: false,
  },
];

/**
 * Carga CFDI con Addenda Component
 */
export default {
    name: "Carga CFDI",
    mixins: [PaginationWithRangeMix],
	setup(){
		return {v$:useVuelidate()};
	},
    components: {
        Layout,
        PageHeader,
        "view-detail": ModalDetalleValidaciones
    },
    data() {
        return {
            totalCDFIRechazados: 0,
            totalCDFIAceptados: 0,
            showBarraProgreso: false,
            actual: 0,
            total: 0,
            cfdisACargar : {
                cfdi_set:[]
            },
            data_to_send: {},
            showModalDetalleValidaciones: false,
            listaRespuestaRecepcion: {
                proveedor_correo: "",
                proveedor_rfc: "",
                uid: "",
                file_number: 0,
                status: "",
                created_at: "",
                origin: "",
                cfdi_set : []
            },
            listaRespuestaRecepcionParaPaginacion: {
                proveedor_correo: "",
                proveedor_rfc: "",
                uid: "",
                file_number: 0,
                status: "",
                created_at: "",
                origin: "",
                cfdi_set : []
            },
            headers,
            // title: "Carga CFDI",
            showTitle: "Subir CFDIs",
            message: "Arrastra el XML",
            extensionsXML: ['xml'],
            // extensionsXML: ['xml', 'zip'],
            accept: acceptXML,
            maxNumberOfFilesXml: 1000,
            maxNumberOfFilesZip: 1,
            buttonSelectMessage: "Seleccionar archivos",
            archivosParaCargar: [],
        };
    },
	validations: {
	},
    mounted() {
    },
    methods: {
        manejarPaginacionCfdiSet(){
            const tablePagination = this.pagination;
            const pag = Object.assign({}, tablePagination);

            this.listaRespuestaRecepcionParaPaginacion = {
                ...this.listaRespuestaRecepcion,
                cfdi_set: [...this.listaRespuestaRecepcion.cfdi_set],
            };

            tablePagination.collectionSize = this.listaRespuestaRecepcionParaPaginacion.file_number;

            tablePagination.actualShow = pag.pageSize;

            // calculo de indices inicio y final para paginación
            const indiceInicio = (pag.page - 1) * pag.pageSize;
            const indiceFinal = pag.page * pag.pageSize;

            // corta array para listar elementos de la página actual
            this.listaRespuestaRecepcionParaPaginacion.cfdi_set = this.listaRespuestaRecepcionParaPaginacion.cfdi_set.slice(indiceInicio, indiceFinal);
        },
        esperar(ms){
            return new Promise((resolve) => setTimeout(resolve, ms));
        },
        async cargarCfdiConAddenda(){

            try {

                this.$refs.uploadFileD.handleFiles([]);

                this.totalCDFIRechazados = 0;
                this.totalCDFIAceptados = 0;

                this.listaRespuestaRecepcion.file_number = 0;
                this.listaRespuestaRecepcion.cfdi_set = [];

                this.listaRespuestaRecepcionParaPaginacion.file_number = 0;
                this.listaRespuestaRecepcionParaPaginacion.cfdi_set = [];

                this.total = this.archivosParaCargar.length;
                this.showBarraProgreso = true;

                    for (const archivo of this.archivosParaCargar) {

                        this.cfdisACargar.cfdi_set.push({
                            xml: archivo.base64,
                            pdf: "dsadas",
                            reference: archivo.item.name,
                        });

                        const response = await service.cargarCfdiConAddenda(this.cfdisACargar);

                        this.cfdisACargar.cfdi_set = [];

                        if(response.success){
                            this.listaRespuestaRecepcion.file_number += response.data.file_number;
                            this.listaRespuestaRecepcion.cfdi_set.push(response.data.cfdi_set[0]);
                            this.manejarPaginacionCfdiSet();
                            this.actual++;
                        }else{
                            console.log('response.success false');
                            console.log(response.data.response.data);
                            this.listaRespuestaRecepcion.cfdi_set = [];
                            await this.$confirm.error("Algo falló, intenta de nuevo por favor");
                        }
                    }

                await this.esperar(2000);
                this.showBarraProgreso = false;
                this.total = 0;
                this.actual = 0;
                this.listaRespuestaRecepcion.cfdi_set.forEach((cfdi) => {
                    if(cfdi.status == "REJECTED"){
                        this.totalCDFIRechazados++;
                    }
                    if(cfdi.status == "ACCEPTED"){
                        this.totalCDFIAceptados++;
                    }
                });
                this.$confirm.informacionCargarCFDI("Información", this.listaRespuestaRecepcion.file_number, this.totalCDFIRechazados, this.totalCDFIAceptados);
            } catch (error) {
                console.log(error.response);
            }
        },
        uploadFile(archivoBase64) {
            this.archivosParaCargar = [];
            this.archivosParaCargar.push(archivoBase64);
        },
        uploadFiles(archivosBase64){
            this.archivosParaCargar = [];
            archivosBase64.forEach((archivo) => {
                this.archivosParaCargar.push(archivo);
            });
        },
        noEsUnCfdi(){
            this.archivosParaCargar = [];
        },
    },
    computed: {
        progressPercent() {
            return (this.actual / this.total) * 100;
        },
        extensions: function () {
            return this.extensionsXML
        },
        disableButtonCargar:function(){
            if(this.archivosParaCargar.length === 0){
                return true;
            }else{
                return false;
            }
        },
    },
    watch: {
    }
};
</script>

<template>
    <Layout>
        <PageHeader title="Carga CFDI Con addenda o complemento pago" />
        <div class="row">
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <upload-file-d
                            ref="uploadFileD"
                            :enableScroll="true"
							:show-button-upload-files="false" 
							:show-gallery="false" 
							:show-table="true"
                            :message="message" 
							:accept="accept" 
							:show-progress="false"
                            :maxNumberOfFilesXml="maxNumberOfFilesXml"
                            :maxNumberOfFilesZip="maxNumberOfFilesZip"
                            :showTitle="showTitle" 
                            :extensions="extensions"
                            :buttonSelectMessage="buttonSelectMessage"
                            :showButtonUploadInTableRow="false"
                            @uploadSelectedBase64File="uploadFile($event)"
                            @uploadSelectedBase64Files="uploadFiles"
                            @noEsUnCfdi="noEsUnCfdi">
                        </upload-file-d>
                    </div>
                    <hr>
                    <div class="row">
                        <div class="progress mb-3 alto-barra-progreso" v-show="showBarraProgreso">
                            <div
                                class="progress-bar progress-bar-striped progress-bar-animated fs-6"
                                role="progressbar"
                                :style="{ width: progressPercent + '%' }"
                                :aria-valuenow="actual"
                                aria-valuemin="0"
                                :aria-valuemax="total"
                            >
                                {{ actual }} de {{ total }}
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-12 col-lg-12 d-flex justify-content-end" v-if="showBarraProgreso==false">
                            <button class="btn btn-success" title="Cargar CFDI" @click="cargarCfdiConAddenda" :disabled="disableButtonCargar">
                                Cargar CFDI
                                <i class="fa fa-file-upload"></i>
                            </button>
                        </div>
                        <div class="col-sm-12 col-md-12 col-lg-12 d-flex justify-content-end" v-if="showBarraProgreso==true">
                            <button class="btn btn-success" title="Cargar CFDI" disabled>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                Cargar CFDI
                                <i class="fa fa-file-upload"></i>
                            </button>
                        </div>
                    </div>
                    <div class="row">
                        <table-pagination
                            :enableScroll="true"
                            :headers="headers" 
                            :pagination="pagination"
                            @on-pagination="pagination = $event"
                            :callback-search="manejarPaginacionCfdiSet"
                        >
                            <template v-slot:tbody>
                                <tr class="table-hover" v-for="item in listaRespuestaRecepcionParaPaginacion.cfdi_set" :key="item.index">
                                    <td>{{ item.reference }}</td>                                    
                                    <td>{{ item.uuid }}</td>
                                    <td>
                                        <span class="badge" :class="item.status == 'ACCEPTED' ? 'bg-success' : 'bg-danger'">
                                            {{item.status == 'ACCEPTED' ? "ACEPTADO" : "RECHAZADO" }}
                                        </span>
                                    </td>
                                    <td>
                                        <div v-for="stage in item.stage_history.stages.filter(stage => !stage.passed)" :key="stage.name">
                                            <div class="texto-error">
                                                {{ stage.validation_error }}
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <button
                                            id="btn_detail_reception"
                                            title="Detalle validaciones"
                                            class="btn btn-sm btn-info"
                                            @click="(showModalDetalleValidaciones = true), (data_to_send = item.stage_history)"
                                        >
                                            <i class="fa fa-eye" aria-hidden="true"></i>
                                        </button>
                                    </td>
                                </tr>
                            </template>
                        </table-pagination>
                    </div>
                </div>
            </div>
        </div>
         <view-detail
            :show-modal="showModalDetalleValidaciones"
            v-on:on-hide="showModalDetalleValidaciones = false"
            :stage_history="data_to_send"
         >
         </view-detail>
    </Layout>
</template>

<style scoped>
.texto-error{
  color: #C70039;
}

.alto-barra-progreso{
    height: 15px;
}
</style>